import { useState, useEffect } from "react";
import { SetLastUser } from "../../services/usersService";
import {
  GetOrCreateReceiptInformation,
  UpdateEtkReceiptInformation,
  GetCheckInSheet,
  UpdateExistingCheckInSheet,
} from "../../services/receiptInfomrationService";
import { InputAdornment } from "@mui/material";
import SampleScannedFormNew from "./SampleScannedFormNew";
import AllSamplesSubmitted from "./AllSamplesSubmitted";
import CheckInSheetSelector from "./CheckInSheetSelector";
import { NotificationManager } from "react-notifications";
import { getFormattedDateTime } from "../../services/dateService";
import { useParams, useNavigate } from "react-router-dom";
import UserSelectorDialog from "../../vlp/components/common/UserSelectorDialog";
import { Grid, TextField } from "@mui/material";
import { Edit as EditIcon, Person as PersonIcon } from "@mui/icons-material";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import { CheckCircle as SuccessIcon } from "@mui/icons-material";
import { CircularProgress, Stack, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

let defaultValues = {
  recordId: null,
  identifier: null,
  userId: null,
  dateReceied: null,
  receivedOn: "Wet Ice",
  coolerTemperature: null,
  deliveryMethod: "PickUp",
  coolerTempAcceptable: null,
  cocCompleted: null,
  containerIntact: null,
  withinHoldingTime: null,
  shortHoldingTime: null,
  sufficientVolume: null,
  noSplit: null,
  isRush: null,
  correctLabels: null,
  headSpacePresent: null,
  labComments: null,
  orderPayType: "",
  ph1: null,
  ph2: null,
  ph3: null,
  ph4: null,
  ph5: null,
  ph6: null,
  ph7: null,
  ph8: null,
  ph9: null,
  ph10: null,
  ph11: null,
  ph12: null,
  isKitPaid: false,
  willRushPay: false,
};

export default function SampleScannedNew({ scannedId,onBack }) {
  const [info, setInfo] = useState(); //the sample receipt information
  const [currentUser, setCurrentUser] = useState();
  const [currentOrderNumber, setCurrentOrderNumber] = useState();
  const [loading, SetLoading] = useState(false);
  const [selectedSampleIds, setSelectedSampleIds] = useState([]);
  // "choose" = order already has submitted sheets, so ask what the user wants to do;
  // "new" = fill in another sheet; "edit" = correct an already-submitted sheet.
  const [mode, setMode] = useState("new");
  const [editingSheet, setEditingSheet] = useState(null);
  // The order-level response, kept aside so the sheet picker and "back" still work
  // after `info` has been swapped for a single sheet being edited.
  const [overview, setOverview] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const [userSelectorOpen, setUserSelectorOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  // Use scannedId prop if provided, otherwise use the id from useParams
  const orderId = scannedId || id;

  useEffect(() => {
    if (!orderId) return;

    setCurrentOrderNumber(orderId);

    async function loadReceiptInformation() {
      var newInfo = defaultValues;
      newInfo.dateReceied = getFormattedDateTime();
      try {
        let response = await GetOrCreateReceiptInformation(orderId);
        if (!response || response.userId === null) {
          NotificationManager.info("New scan", "Sample Receipt");
          newInfo.recordId = response.recordId;
          newInfo.identifier = response.identifier;
          newInfo.isKitPaid = response.isKitPaid;
          newInfo.willRushPay = response.willRushPay;
          newInfo.orderPayType = response.orderPayType;
          newInfo.selectedKit = response.selectedKit;
          newInfo.checkInSheetCount = response.checkInSheetCount;
          newInfo.totalSampleCount = response.totalSampleCount;
          newInfo.remainingSampleCount = response.remainingSampleCount;
          newInfo.allSamplesSubmitted = response.allSamplesSubmitted;
          newInfo.unsubmittedSamples = response.unsubmittedSamples;
        } else {
          NotificationManager.info(
            "An existing scan was found",
            "Sample Receipt"
          );
          // Prefill the checklist with the previous submission's answers, but the
          // sample selection below always reflects what's still outstanding now.
          response.dateReceied = getFormattedDateTime(response.dateReceied);
          newInfo = response;
        }
      } catch (err) {
        NotificationManager.error(err.toString());
      }
      setInfo(newInfo);
      setOverview({ ...newInfo });
      // Default to "submit everything still outstanding" -- most check-ins
      // cover the whole remaining batch in one go.
      setSelectedSampleIds((newInfo.unsubmittedSamples || []).map((s) => s.sampleRecordId));
      // Anything already submitted means the user might have come here to fix a
      // previous sheet rather than add another, so ask before assuming.
      setMode((newInfo.submittedSheets || []).length > 0 ? "choose" : "new");
    }

    loadReceiptInformation();
  }, [orderId]);

  const handleUserSelect = (user) => {
    if (user) {
      setSelectedUser(user);
      setCurrentUser(user.operator);
      SetLastUser(user.operator);
    }
  };

  const handleStartNew = () => {
    setMode("new");
  };

  const handleEditSheet = async (sheet) => {
    SetLoading(true);
    try {
      const sheetInfo = await GetCheckInSheet(orderId, sheet.recordId);
      sheetInfo.dateReceied = getFormattedDateTime(sheetInfo.dateReceied);
      setInfo(sheetInfo);
      setEditingSheet({ recordId: sheet.recordId, sheetNumber: sheetInfo.sheetNumber });
      // A submitted sheet's samples are fixed, so there's no selection to carry.
      setSelectedSampleIds([]);

      // Default to whoever originally signed the sheet rather than making the user
      // re-pick just to save a correction.
      const originalOperator = (sheetInfo.userId || "").trim();
      if (originalOperator) {
        setCurrentUser(originalOperator);
        // Display-only stand-in so the User field shows the operator we'd actually
        // save. The user can still click through to change it.
        setSelectedUser({ operator: originalOperator, aliasName: "" });
      }

      setMode("edit");
    } catch (err) {
      NotificationManager.error("Error loading the check-in sheet. " + err, "Error");
    }
    SetLoading(false);
  };

  const onSubmit = async (data) => {
    SetLoading(true);
    if (data.UserId == null) {
      data.userId = currentUser;
    }

    try {
      if (mode === "edit" && editingSheet) {
        // Sample assignments are fixed server-side for an existing sheet.
        delete data.selectedSampleRecordIds;
        await UpdateExistingCheckInSheet(orderId, editingSheet.recordId, data);
        NotificationManager.success(
          `Check-In Sheet #${editingSheet.sheetNumber} updated.`,
          "Sample Receipt"
        );
      } else {
        data.selectedSampleRecordIds = selectedSampleIds;
        await UpdateEtkReceiptInformation(data);
      }
      closeCheckIn();
    } catch (err) {
      NotificationManager.error("Error submitting. " + err, "Error");
    }
    SetLoading(false);
  };

  const onResetHeadSpace = () => {
    let infoValue = info;
    infoValue.headSpacePresent = null;
    setInfo(infoValue);
  };

  const closeCheckIn = () => {
    if (onBack) {
      onBack();
    } else {
      navigate("/vlp/scan");
    }
  };

  const handleBackClick = () => {
    // When the order has submitted sheets, step back to the picker instead of
    // closing outright -- the user may have opened the wrong sheet.
    if (mode !== "choose" && (overview?.submittedSheets || []).length > 0) {
      setInfo(overview);
      setEditingSheet(null);
      setSelectedSampleIds(
        (overview.unsubmittedSamples || []).map((s) => s.sampleRecordId)
      );
      setMode("choose");
      return;
    }

    closeCheckIn();
  };

  return (
    <>
      <Box sx={{ p: 3 }}>
        <Card elevation={2} sx={{ borderRadius: 2, overflow: "hidden" }}>
          <CardContent sx={{ p: 0 }}>
            {/* Processing Header */}
            <Box
              sx={{
                backgroundColor: "white",
                borderBottom: 1,
                borderColor: "divider",
                p: 3,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box display="flex" alignItems="center">
                <Box
                  sx={{
                    backgroundColor: "success.main",
                    color: "white",
                    borderRadius: 2,
                    p: 1,
                    mr: 2,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <SuccessIcon sx={{ fontSize: 28 }} />
                </Box>
                <Box>
                  <Typography
                    variant="h4"
                    component="h1"
                    fontWeight="700"
                    color="text.primary"
                  >
                    Processing Sample
                  </Typography>
                  <Typography
                    variant="h6"
                    color="text.secondary"
                    sx={{ mt: 0.5, fontFamily: "monospace" }}
                  >
                    ID: {orderId}
                  </Typography>
                </Box>
              </Box>

              {/* Right side actions */}
              <Stack direction="row" spacing={2} alignItems="center">
                <IconButton color="warning" onClick={handleBackClick}>
                  <ArrowBackIcon />
                </IconButton>
                <Typography variant="h6" fontWeight="bold">
                  {currentOrderNumber}
                </Typography>
                <TextField
                  label="User"
                  value={
                    selectedUser
                      ? `${selectedUser.operator.trim()} - ${selectedUser.aliasName.trim()}`
                      : "Click to select user"
                  }
                  size="small"
                  onClick={() => setUserSelectorOpen(true)}
                  InputProps={{
                    readOnly: true,
                    style: { cursor: "pointer" },
                    startAdornment: !selectedUser && (
                      <InputAdornment position="start">
                        <PersonIcon color="primary" />
                      </InputAdornment>
                    ),
                    endAdornment: selectedUser && (
                      <InputAdornment position="end">
                        <EditIcon color="primary" sx={{ fontSize: 20 }} />
                      </InputAdornment>
                    ),
                  }}
                />
              </Stack>
            </Box>
          </CardContent>
        </Card>

        {/* User selector dialog */}
        <UserSelectorDialog
          open={userSelectorOpen}
          onClose={() => setUserSelectorOpen(false)}
          onSelect={handleUserSelect}
          multiSelect={false}
          filter="SHIPPING"
        />

        {/* Content */}
        <Box sx={{ mt: 3 }}>
          {overview && mode === "choose" ? (
            <CheckInSheetSelector
              orderId={orderId}
              submittedSheets={overview.submittedSheets}
              totalSampleCount={overview.totalSampleCount}
              remainingSampleCount={overview.remainingSampleCount}
              onStartNew={handleStartNew}
              onEditSheet={handleEditSheet}
              onBack={closeCheckIn}
            />
          ) : info && mode !== "edit" && info.allSamplesSubmitted ? (
            <AllSamplesSubmitted
              orderId={orderId}
              checkInSheetCount={info.checkInSheetCount}
              totalSampleCount={info.totalSampleCount}
              onBack={handleBackClick}
            />
          ) : info ? (
            <SampleScannedFormNew
              model={info}
              isLoading={loading}
              onSubmit={onSubmit}
              onResetHeadSpace={onResetHeadSpace}
              orderNumber = {orderId}
              unsubmittedSamples={info.unsubmittedSamples}
              selectedSampleIds={selectedSampleIds}
              onSelectedSampleIdsChange={setSelectedSampleIds}
              checkInSheetCount={info.checkInSheetCount}
              totalSampleCount={info.totalSampleCount}
              remainingSampleCount={info.remainingSampleCount}
              isEditing={mode === "edit"}
              sheetSamples={info.samples}
              sheetNumber={editingSheet?.sheetNumber}
            />
          ) : (
            <Box display="flex" justifyContent="center" mt={5}>
              <CircularProgress color="info" size={60} />
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
}
